<main>
	<div class="row bg-light p-5">
		<div class="col-6 text-center">
			<a
				class="btn btn-outline-secondary"
				target="_blank"
				[href]="googlePlayURL"
				[attr.data-anchor-tracked]='{"cat":"External", "action":"Mobile-APP", "label":"Android"}'
			>
				<i class="main-blue-hover fa fa-android fa-5x" aria-hidden="true"></i>
			</a>
			<br>
			<strong class="text-secondary">Android</strong>
		</div>

		<div class="col-6 text-center">
			<a
				class="btn btn-outline-secondary"
				target="_blank"
				[href]="appStoreURL"
				[attr.data-anchor-tracked]='{"cat":"External", "action":"Mobile-APP", "label":"iOS"}'
			>
				<i class="main-blue-hover fa fa-apple fa-5x" aria-hidden="true"></i>
			</a>
			<br>
			<strong class="text-secondary">iOS</strong>
		</div>
	</div>
</main>
